import { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import MojitoModules from 'mojito/modules';
import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import { isEmpty } from 'mojito/utils';

import HomePage from 'applications/sports/pages/home-page/index.js';
import { navigateToBetEvents } from './deep-linking-routing.js';

const {
    utils: BetslipUtils,
    selectors: { selectDeepLinkingBets },
} = MojitoServices.Betslip;
const { selectEvents } = MojitoServices.SportsContent.Events.selectors;
const { useContentItems, useEventsChunkRequest, useEventsLoadDone } = MojitoModules.Common.Hooks;
const { useInstanceId } = MojitoCore.Presentation.Hooks;
const { IntentActionTrigger } = MojitoPresentation.Base.Intent;

export default memo(function DeepLinkingBetsResolveController(props) {
    const deepLinkingBets = useSelector(state => selectDeepLinkingBets(state));
    return Array.isArray(deepLinkingBets) ? (
        <DeepLinkingRoutingController {...props} />
    ) : (
        <HomePage />
    );
});

function DeepLinkingRoutingController({ skipNavigation }) {
    // the number of deep linking bets should be always the same (from render to render)
    const deepLinkingBets = useSelector(state => selectDeepLinkingBets(state));
    const eventIds = !skipNavigation
        ? deepLinkingBets.map(bet => {
              const { eventId } = BetslipUtils.getFirstBetPart(bet).partInfo || {};
              return eventId;
          })
        : undefined;
    const events = useEventItems(eventIds);
    const eventsLoadDone = useEventsLoadDone(eventIds);

    const allEventsAvailable = eventsLoadDone && deepLinkingBets.length === events?.length;
    const someEventsUnavailable = eventsLoadDone && events?.length !== deepLinkingBets.length;

    useEffect(() => {
        if (someEventsUnavailable || skipNavigation) {
            IntentActionTrigger.showHomePage(true);
            return;
        }
        if (allEventsAvailable) {
            navigateToBetEvents(events);
        }
    }, [allEventsAvailable, someEventsUnavailable, events, skipNavigation]);

    return <HomePage />;
}

const useEventItems = eventIds => {
    const instanceId = useInstanceId();
    useEventsChunkRequest(eventIds, instanceId);
    const events = useContentItems(selectEvents, eventIds);
    return !isEmpty(events) ? events.filter(Boolean) : undefined;
};
